export default {
    AvailableStartTime: 'تاریخ شروع',
    AvailableStartTimeMin: 'تاریخ شروع از',
    AvailableStartTimeMax: 'تاریخ شروع تا',
    AvailableExpireTime: 'تاریخ انقضا',
    AvailableExpireTimeMin: 'تاریخ انقضا از',
    AvailableExpireTimeMax: 'تاریخ انقضا تا',
    StateId: 'وضعیت'
}